import { useEffect, useState } from "react";
import moment from "moment-timezone";
import {
  DEFAULT_DASHBOARD_LAYOUT_CONFIG,
  DEFAULT_DASHBOARD_MENU,
  DEFAULT_DISCOVERY_ALERT_POPUP,
  DEFAULT_DISCOVERY_COLUMNS,
  SHOW_ALL_DISCOVERY_FILTER,
  DEFAULT_DISCOVERY_SECTOR,
  DEFAULT_DISCOVERY_SETTING_LIST,
  DEFAULT_DISCOVERY_SORT,
  DEFAULT_HALT_CONFIG,
  DEFAULT_MONEYFLOW_DATA,
  DEFAULT_NEWS_CONFIG,
  DEFAULT_OPTIONS_MODE,
  DEFAULT_STREAM_SETTING,
  DEFAULT_STREAM_SETTING_LIST,
  DEFAULT_TREND_DATA,
  DEFAULT_VOICE_BUFFER,
  DEFAULT_VOLUME_DATA,
  STREAM_CHANNEL_MODE,
  TIMEFRAME_TRANSFORM_MAP,
  DEFAULT_QUOTE_CONFIG,
  isActiveSubscription,
  isPro,
  isProNew,
  isProPlusNew,
  DISCOVERY_MAX_COLUMN_CNT,
  DISCOVERY_COLUMN_LABELS,
  TIMEFRAME_FILTER,
  TIMEFRAME_INVERSE_TRANSFORM_MAP,
} from "./constants";
import Holidays from "date-holidays";
import _ from "lodash";

export function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validateUrl(url) {
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    url
  );
}

export function delay(milisec) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, Math.max(milisec, 0));
  });
}

export function isWebAppStandalone() {
  const STANDALONE = ":standalone:";
  const hash = window.location.hash;

  let standalone = false;

  if (hash === "#" + STANDALONE) {
    standalone = true;
    // eslint-disable-next-line no-restricted-globals
    history.replaceState(history.state, "", "/");
  }

  if (matchMedia("(display-mode)").matches) {
    return matchMedia("(display-mode: standalone)").matches;
  }

  if (standalone) {
    sessionStorage.setItem(STANDALONE, "1");
  } else if (sessionStorage.getItem(STANDALONE)) {
    standalone = true;
  }

  return standalone;
}

export function getInteger(value) {
  if (isNaN(value)) {
    return "_";
  }
  let res = parseInt(value);
  if (res === 0 && value < 0) {
    res = "-" + res;
  }
  return res;
}

export function getDecimal(value, length = 1) {
  if (isNaN(value)) {
    return "_";
  }
  let decimal = Math.abs(value % 1);
  if (!decimal) {
    return "";
  }
  return (decimal + "000000000000").slice(1, 2 + length);
}

export function checkModified(a, b, ignorePaths) {
  const ignorePath = (path) => {
    return ignorePaths && ignorePaths.some((regex) => regex.test(path));
  };
  const isModified = (origin, data, path) => {
    const keys = Object.keys(data);

    for (let i = 0; i < keys.length; i++) {
      const childPath = `${path}.${keys[i]}`;
      if (!ignorePath(childPath)) {
        if (
          Object.prototype.toString.call(data[keys[i]]) == "[object Object]" ||
          Object.prototype.toString.call(data[keys[i]]) == "[object Array]"
        ) {
          if (!origin[keys[i]]) {
            return true;
          }

          if (isModified(origin[keys[i]], data[keys[i]], childPath)) {
            return true;
          }

          continue;
        }
        if (data[keys[i]] == null || data[keys[i]] == "") {
          if (origin[keys[i]] != null && origin[keys[i]] != "") {
            return true;
          }

          continue;
        }
        if (data[keys[i]] != origin[keys[i]]) {
          return true;
        }
      }
    }

    return false;
  };

  return isModified(a, b, "") || isModified(b, a, "");
}

export function useMediaQueryDetector(query) {
  const [match, setMatch] = useState(false);

  useEffect(() => {
    const matches = window.matchMedia(query);
    setMatch(matches.matches);

    matches.addEventListener && matches.addEventListener("change", onChangeMatchMediaQuery);

    return () => matches.removeEventListener && matches.removeEventListener("change", onChangeMatchMediaQuery);
  }, [query]);

  const onChangeMatchMediaQuery = (e) => {
    setMatch(e.matches);
  };

  return [match];
}

export function getMarketStartEndTime(ESTTime, params = {}) {
  const { regularHours } = params;
  let marketStartTime = moment(new Date())
    .tz("America/New_York")
    .set("hour", 4)
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0);
  if (regularHours) {
    marketStartTime = moment(new Date())
      .tz("America/New_York")
      .set("hour", 9)
      .set("minute", 30)
      .set("second", 0)
      .set("millisecond", 0);
  }

  if (ESTTime.isAfter(marketStartTime)) {
    marketStartTime.add("day", 1);
  }
  if (marketStartTime.day() === 0) {
    marketStartTime.day(1);
  } else if (marketStartTime.day() === 6) {
    marketStartTime.day(1 + 7);
  }

  let marketEndTime = moment(marketStartTime)
    .tz("America/New_York")
    .set("hour", 20)
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0);
  if (regularHours) {
    marketEndTime = moment(marketStartTime)
      .tz("America/New_York")
      .set("hour", 16)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
  }

  marketEndTime.subtract("day", 1);
  if (marketEndTime.day() === 0) {
    marketEndTime.day(5 - 7);
  } else if (marketEndTime.day() === 6) {
    marketEndTime.day(5);
  }
  return {
    start: marketStartTime,
    end: marketEndTime,
  };
}

export function isMarketOpen() {
  const ESTTime = moment(new Date()).tz("America/New_York");
  const { start: marketStartTime, end: marketEndTime } = getMarketStartEndTime(ESTTime);
  return !ESTTime.isBetween(marketEndTime, marketStartTime);
}

export function isRegularMarketOpen() {
  const ESTTime = moment(new Date()).tz("America/New_York");
  const { start: marketStartTime, end: marketEndTime } = getMarketStartEndTime(ESTTime, { regularHours: true });
  return !ESTTime.isBetween(marketEndTime, marketStartTime);
}

/**
 * Returns current user subscription status
 * isPro, isProOld, and isProPlus
 *
 * @param {object} auth : user data
 * @returns {object} user subscription status
 */
export function getPlanSubscriptionStatus(auth) {
  if (!auth?.user?.subscription) {
    return {};
  }
  return {
    isPro:
      isActiveSubscription(auth.user.subscription) &&
      (isPro(auth.user.subscription.plan) || isProNew(auth.user.subscription.plan)),
    isProOld: isActiveSubscription(auth.user.subscription) && isPro(auth.user.subscription.plan),
    isProPlus: isActiveSubscription(auth.user.subscription) && isProPlusNew(auth.user.subscription.plan),
  };
}

/**
 * Checks if the Discovery column can be accessible to the user
 *
 * @param {object} item : Discovery column item
 * @param {object} plan : user subscription status
 * @returns {boolean} true if user can access the column
 */
export const isColumnAccessible = (item, plan) => {
  if (!plan.isProOld && !plan.isPro && !plan.isProPlus) {
    return false;
  }
  const { column, custom } = item || {};
  if (custom) {
    return plan.isProPlus;
  }
  if (column === "squeeze" || column === "moneyflow") {
    return plan.isProPlus || plan.isProOld;
  }
  if (
    column === "trend" ||
    column === "short_ratio" ||
    column === "atr" ||
    column === "gap" ||
    column === "tradeCount" ||
    column === "vWapSlope" ||
    column === "sparkline"
  ) {
    return plan.isProPlus;
  }
  return true;
};

/**
 * Checks if the Discovery field can be accessible to the user
 * @param {string} column - The name of the column to check.
 * @param {object} plan - The subscription plan.
 * @returns {boolean} True if the column is accessible, false otherwise.
 */
export function isFieldAccessible(column, plan) {
  if (!plan.isProOld && !plan.isPro && !plan.isProPlus) {
    return false;
  }
  if (column === "squeeze" || column === "mf_price" || column === "mf_dist") {
    return plan.isProPlus || plan.isProOld;
  }
  if (
    column === "trend" ||
    column === "short_ratio" ||
    column === "atr" ||
    column === "gap" ||
    column === "tradeCount" ||
    column === "tradeCount_dist" ||
    column === "vWapSlope"
  ) {
    return plan.isProPlus;
  }
  if (column === "news") {
    return plan.isProPlus || plan.isProOld || plan.isPro;
  }
  return true;
}

/**
 * Returns the plan name that can access the specified column.
 * @param {string} column The name of the column to check.
 * @returns {string|null} The plan name that can access the column, or null if all plans can access the column.
 */
export function getInaccessibleFieldPlanName(column) {
  const planChoices = [
    { plan: {}, name: null },
    { plan: { isPro: true }, name: "Pro" },
    { plan: { isProOld: true }, name: "Pro+" },
    { plan: { isProPlus: true }, name: "Pro+" },
  ];

  let plan;
  for (const planItem of planChoices) {
    let pass = true;
    pass = pass && isFieldAccessible(column, planItem.plan);
    if (pass) {
      plan = planItem.name;
      break;
    }
  }
  return plan;
}

/**
 * Returns label string for a Discovery column
 *
 * @param {object | string} item : Column object or Column string
 * @returns {string} Returns column title to be shown in Settings or Column dropdown
 */
export const getDiscoveryColumnTitle = (item) => {
  let label = "";
  if (typeof item === "string") {
    label = DISCOVERY_COLUMN_LABELS[item];
  } else if (typeof item === "object") {
    const { column, custom, timeframe } = item;
    label = DISCOVERY_COLUMN_LABELS[column];
    if (custom) {
      label = `${label} (${TIMEFRAME_FILTER[timeframe]})`;
    }
  }
  return label;
};

/**
 * Extracts only custom Discovery columns
 *
 * @param {array} columns : array of Discovery columns
 * @param {object} auth : User auth object
 */
export const getDiscoveryCustomColumns = (columns, auth, includeHidden = false) => {
  if (!Array.isArray(columns)) {
    return [];
  }
  const plan = getPlanSubscriptionStatus(auth);
  return columns.filter((item) => item.custom && (includeHidden || !item.hidden) && isColumnAccessible(item, plan));
};

/**
 * Extracts unique timeframe list from a Discovery widget custom columns
 *
 * @param {array} columns : array of Discovery columns
 * @param {object} auth : User auth object
 */
export const getDiscoveryCustomColumnTimeframes = (columns, auth, includeHidden = false) => {
  return _.uniq(getDiscoveryCustomColumns(columns, auth, includeHidden).map((item) => item.timeframe));
};

export const encodeDiscoveryFieldForTimeframe = (column, timeframe) => {
  let encoded = column;
  if (timeframe) {
    encoded = `__${column}__${timeframe}`;
  }
  return encoded;
};

export const encodeDiscoveryFieldTitleForTimeframe = (title, timeframe) => {
  let encoded = title;
  if (timeframe) {
    encoded = `${title} (${timeframe})`;
  }
  return encoded;
};

export const decodeDiscoveryFieldForTimeframe = (columnKey) => {
  const columnInfo = {
    column: columnKey,
  };
  const regex = /^__(?<column>.+)__(?<timeframe>.+)$/;
  const m = regex.exec(columnKey);
  if (m) {
    columnInfo.column = m.groups.column;
    columnInfo.timeframe = m.groups.timeframe;
  }
  return columnInfo;
};

/**
 * functions for store data complement
 */
export function complementConfig(data, auth, limitColumnCnt) {
  let { discovery, stream, news, voiceNoti, voiceBuffer, optionsMode, halt, quote } = data || {};
  if (!discovery || !Array.isArray(discovery)) {
    discovery = DEFAULT_DISCOVERY_SETTING_LIST;
  }
  if (!discovery[0].id) {
    discovery = [
      {
        ...DEFAULT_DISCOVERY_SETTING_LIST[0],
        value: discovery,
      },
      ...DEFAULT_DISCOVERY_SETTING_LIST.slice(1),
    ];
  }

  // Complement Discovery column settings
  const plan = getPlanSubscriptionStatus(auth);
  for (const configItem of discovery) {
    if (!(configItem.value?.length > 0)) {
      configItem.value = DEFAULT_DISCOVERY_COLUMNS;
      continue;
    }
    const newColumnValue = [...configItem.value];

    const configColumnList = configItem.value.map(({ column }) => column);
    const defaultColumnList = DEFAULT_DISCOVERY_COLUMNS.map(({ column }) => column);

    for (let i = 0; i < DEFAULT_DISCOVERY_COLUMNS.length; i++) {
      const defaultColumn = DEFAULT_DISCOVERY_COLUMNS[i];
      if (!configColumnList.includes(defaultColumn.column)) {
        newColumnValue.splice(i, 0, defaultColumn);
      }
    }

    for (let i = 0; i < newColumnValue.length; i++) {
      const configColumn = newColumnValue[i];
      if (!defaultColumnList.includes(configColumn.column)) {
        newColumnValue.splice(i, 1);
        i--;
      }
    }

    if (auth && limitColumnCnt) {
      let visibleColumnCnt = 0;
      for (let i = 0; i < newColumnValue.length; i++) {
        const configColumn = newColumnValue[i];
        if (!configColumn.hidden && isColumnAccessible(configColumn, plan)) {
          visibleColumnCnt++;
          if (visibleColumnCnt > DISCOVERY_MAX_COLUMN_CNT) {
            configColumn.hidden = true;
            visibleColumnCnt--;
          }
        }
      }
    }

    configItem.value = newColumnValue;
  }

  if (!stream || !Array.isArray(stream)) {
    stream = DEFAULT_STREAM_SETTING_LIST;
  }
  for (const item of stream) {
    // if (!item.color) {
    //   item.color = '#c40000';
    // }
    if (!item.mode) {
      item.mode = STREAM_CHANNEL_MODE.DEFAULT;
    }
    if (!item.haltluld) {
      item.haltluld = { halt: true, luld: true };
    }
    if (item.channel === "main") {
      item.channel = "stream1";
      item.title = "Stream 1";
    }
    if (item.channel === "alt") {
      item.channel = "stream2";
      item.title = "Stream 2";
      item.color = "#eedb66";
    }
    if (!item.value) item.value = DEFAULT_STREAM_SETTING;
    if (!item.value.float) item.value.float = DEFAULT_STREAM_SETTING.float;
    if (!item.value.price) item.value.price = DEFAULT_STREAM_SETTING.price;
    if (!item.value.volume) item.value.volume = DEFAULT_STREAM_SETTING.volume;
    if (!item.value.count) item.value.count = DEFAULT_STREAM_SETTING.count;
    if (!item.value.atr) item.value.atr = DEFAULT_STREAM_SETTING.atr;
    if (!item.value.gap) item.value.gap = DEFAULT_STREAM_SETTING.gap;
    if (!item.value.marketCap) item.value.marketCap = DEFAULT_STREAM_SETTING.marketCap;
  }
  if (!news) {
    news = DEFAULT_NEWS_CONFIG;
  }
  if (!voiceNoti) {
    voiceNoti = [];
  }
  if (voiceBuffer == null) {
    voiceBuffer = DEFAULT_VOICE_BUFFER;
  }
  if (!halt) {
    halt = DEFAULT_HALT_CONFIG;
  }
  if (!quote) {
    quote = DEFAULT_QUOTE_CONFIG;
  }
  return {
    discovery,
    stream,
    news,
    voiceNoti,
    voiceBuffer,
    optionsMode: optionsMode || DEFAULT_OPTIONS_MODE,
    halt,
    quote,
  };
}

export function complementLayout(layout) {
  if (Array.isArray(layout)) {
    for (const item of layout) {
      delete item.menu;
      delete item.layout;
      delete item.popout;
    }
  }
  return layout;
}

export function complementDiscovery(data) {
  const discovery = { ...data };

  if (!discovery.discoverySector.discovery1) {
    discovery.discoverySector = {
      discovery1: discovery.discoverySector,
      discovery2: [DEFAULT_DISCOVERY_SECTOR],
    };
  }

  if (!discovery.moneyFlowData.discovery1) {
    discovery.moneyFlowData = {
      discovery1: discovery.moneyFlowData,
      discovery2: DEFAULT_MONEYFLOW_DATA,
    };
  }

  if (!discovery.volumeData.discovery1) {
    discovery.volumeData = {
      discovery1: discovery.volumeData,
      discovery2: DEFAULT_VOLUME_DATA,
    };
  }

  if (!discovery.trendData.discovery1) {
    discovery.trendData = {
      discovery1: discovery.trendData,
      discovery2: DEFAULT_TREND_DATA,
    };
  }

  if (typeof discovery.isFavFilter === "boolean") {
    discovery.isFavFilter = {
      discovery1: discovery.isFavFilter,
      discovery2: false,
    };
  }

  if (typeof discovery.selectedTableFilter !== "object") {
    discovery.selectedTableFilter = {
      discovery1: discovery.selectedTableFilter,
      discovery2: SHOW_ALL_DISCOVERY_FILTER,
    };
  }

  if (typeof discovery.discoverAlerySelected !== "object") {
    discovery.discoverAlerySelected = {
      discovery1: discovery.discoverAlerySelected,
      discovery2: DEFAULT_DISCOVERY_ALERT_POPUP,
    };
  }

  if (typeof discovery.discoveryTimeframe !== "object") {
    discovery.discoveryTimeframe = {
      discovery1: discovery.discoveryTimeframe,
      discovery2: "1day",
    };
  }

  if (!discovery.discoverySort.discovery1) {
    discovery.discoverySort = {
      discovery1: discovery.discoverySort,
      discovery2: DEFAULT_DISCOVERY_SORT,
    };
  }

  if (typeof discovery.discoveryFilter !== "object") {
    discovery.discoveryFilter = {
      discovery1: discovery.discoveryFilter,
      discovery2: "",
    };
  }

  if (typeof discovery.discoveryFilterExactMatch !== "object") {
    discovery.discoveryFilterExactMatch = {
      discovery1: discovery.discoveryFilterExactMatch,
      discovery2: false,
    };
  }

  if (typeof discovery.viewportSymbols !== "object") {
    discovery.viewportSymbols = {
      discovery1: [],
      discovery2: [],
    };
  }

  return discovery;
}

export function complementFlow(data) {
  let { filter, ...other } = data || {};
  if (!filter.hasOwnProperty("price") || filter.price < 0) {
    filter.price = 0;
  }
  return {
    ...other,
    filter,
  };
}

/**
 * add GTM analytics scripts
 */
export function addGTMAnalyticsScripts() {
  const headScriptId = "gtm-analytics-head";
  const bodyScriptId = "gtm-analytics-body";
  document.getElementById(headScriptId)?.remove();
  document.getElementById(bodyScriptId)?.remove();

  const s1 = document.createElement("script");
  s1.id = headScriptId;
  s1.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-5VSPCF');
  `;
  document.head.appendChild(s1);

  const s2 = document.createElement("noscript");
  s2.id = bodyScriptId;
  s2.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5VSPCF"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.body.appendChild(s2);
}

export function timeframeToUnit(tf, ms) {
  if (!TIMEFRAME_INVERSE_TRANSFORM_MAP[tf]) throw new Error("Invalid timeframe");

  const min = 60 * 1000;
  const hr = 60 * 60 * 1000;
  const dy = 24 * hr;

  if (!tf) return;
  if (tf.includes("mo")) return ms ? dy * 30 : "month";
  if (tf.includes("m")) return ms ? min : "minute";
  if (tf.includes("h")) return ms ? hr : "hour";
  if (tf.includes("d")) return ms ? dy : "day";
  if (tf.includes("w")) return ms ? dy * 7 : "week";
}
export function timeframeToMs(tf) {
  if (!TIMEFRAME_INVERSE_TRANSFORM_MAP[tf]) throw new Error("Invalid timeframe");

  const value = tf.match(/^\d*/)[0];
  const unit = timeframeToUnit(tf, true);
  return value * unit;
}

export function checkOnHoliday(date) {
  date = moment(date);

  const holidayNames = [
    "New Year's Day",
    "Martin Luther King Jr. Day",
    "Washington's Birthday",
    "Memorial Day",
    "Juneteenth",
    "Independence Day",
    "Labor Day",
    "Thanksgiving Day",
    "Christmas Day",
  ];

  const hd = new Holidays();
  hd.init("US");

  const fullHolidays = hd.getHolidays(date.year());
  const holidays = fullHolidays.filter((hd) => holidayNames.includes(hd.name)).map((hd) => hd.date);
  holidays.push(GoodFriday(date.year()));

  return !!holidays.find((hd) => {
    hd = moment(hd);
    return hd.format("YYYY-MM-DD") === date.format("YYYY-MM-DD");
  });

  function GoodFriday(Y) {
    let C = Math.floor(Y / 100);
    let N = Y - 19 * Math.floor(Y / 19);
    let K = Math.floor((C - 17) / 25);
    let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor(I / 30);
    I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
    let J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    let L = I - J;
    let M = 3 + Math.floor((L + 40) / 44);
    let D = L + 28 - 31 * Math.floor(M / 4);

    return new Date(Y, M - 1, D - 2);
  }
}
